import vademecum22 from "../../../services/asegurator/asegurator-medicine.js";

import providerService from "../../../services/provider/ProviderService.js";
import locationService from "../../../services/location/LocationService.js";
import vademecum from "../../../services/vademecum/Vademecum.js";
import kardex from "../../../services/kardex/kardex-medicine.js";
import * as moment from "moment";
import XLSX from "xlsx";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Cadenas",
          sortable: false,
        },
        {
          text: "Farmacia origen",
          sortable: false,
        },
        {
          text: "Farmacia destino",
          sortable: false,
        },
        {
          text: "PLU",
          sortable: false,
        },
        {
          text: "Medicamento",
          sortable: false,
        },
        {
          text: "Lote",
          sortable: false,
        },
        {
          text: "Cantidad",
          sortable: false,
        },
        {
          text: "Estado",
          sortable: false,
        },
      ],
      loading: false,
      pagination: {},
      searchType: "",
      provider: null,
      searchTypes: [
        { text: "Cadena", value: "provider" },
        { text: "Farmacia", value: "branch" },
        { text: "Medicamento", value: "medicine" },
        { text: "Lote", value: "lote" },
      ],
      itemsData: [],
      itemsDatatotal: [],
      providers: [],
      branches: [],
      vademecumData: [],
      nroRows: 0,
      minDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      date: "",
      date2: "",
      dataPicker2: false,
      dataPicker: false,
      totalrecords: 0
    };
  },
  props: ["providers", "vademecumData"],
  watch: {
    pagination: {
      handler() {
        this.searchCity();
      },
      deep: true,
    },
    searchType(newValue, oldValue) {
      // Vaciar la variable search cuando cambie searchType
      this.search = "";
    },
  },
  created() {
    // this.getProviders();
    // this.getMedicines();
    //this.downloadexcel();
  },
  computed: {
    customHeaders() {
      return this.enabledColumns
        ? this.headers.filter((header) => this.enabledColumns[header.id])
        : this.headers;
    },
  },
  // mounted() {
  //     this.searchCity();
  // },
  methods: {
    async downloadexcel() {
      await kardex
        .getKarderTransferData(
          1,
          this.totalrecords,
          this.search,
          this.date,
          this.date2,
          this.searchType
        )
        .then((response) => {
          this.itemsDatatotal = response.data[0];
        });
    },
    filterFunction(item, queryText) {
      return (
        item.plu.includes(queryText) ||
        item.description.toLowerCase().includes(queryText.toLowerCase()) ||
        item.id.includes(queryText)
      );
    },
    validateSearchType() {
      if (!this.searchType === "") {
        this.search = "";
      }
    },
    async exportToExcel() {
      await this.downloadexcel();
      const filteredData = this.itemsDatatotal.map((item) => ({
        Prestador: item.source_provider,
        "Farmacia origen": item.source_name_branch,
        "Farmacia destino": item.target_name_branch,
        Plu: item.plu,
        Medicamento: item.name_medicine,
        Lote: item.lote,
        Fecha: new Date(item.createDate).toLocaleDateString(),
        Cantidad: item.quantity,
        Estado: this.transferStatus(item.status),
      }));

      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const date = new Date();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 || 12; // Convierte las 24 horas al formato de 12 horas

      // Formatea la hora en el formato HH-MM-AM/PM
      const formattedTime = `${formattedHours
        .toString()
        .padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${ampm}`;

      // Concatena la fecha y hora al nombre del archivo
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}_${formattedTime}`;

      const fileName = `Transferencias_kardex_${formattedDate}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    },
    async Provider(providerId) {
      this.branches = [];
      return await locationService
        .getBranchesByProvider(providerId)
        .then((response) => {
          this.branches = response.data;
          if (this.branches && this.branches.code) {
            this.branches = [];
          }
        });
    },
    changeInitialDate() {
      let initialDate = moment(this.date).format("YYYY-MM-DD");
      this.minDate = initialDate;
      if (
        (this.date2 !== null) & (this.date2 !== undefined) &&
        this.date2 !== ""
      ) {
        if (!moment(this.date2).isSameOrAfter(initialDate)) {
          this.date2 = this.minDate;
        }
      }
    },
    // getMedicines() {
    //     vademecum.getVademecumOrder().then((response) => {
    //         this.vademecumData = response.data;
    //         for (let index = 0; index < this.vademecumData.length; index++) {
    //             const medicinee = this.vademecumData[index];
    //             // if (medicinee.isApplicable || medicinee.isWatched) {
    //             //     this.vademecumData[index].disabled = true;
    //             // }
    //         }
    //         return this.vademecumData;
    //     });
    // },
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    searchCity() {
      this.loading = true;

      if (
        (this.searchType == "branch" ||
          this.searchType == "provider" ||
          this.searchType == "medicine") &&
        this.search == ""
      ) {
        this.loading = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "No pueden quedar campos sin seleccionar",
        });
        return;
      } else {
        const { page, rowsPerPage } = this.pagination;
        if (this.date == null) {
          this.date = "";
        }
        if (this.date2 == null) {
          this.date2 = "";
        }
        kardex
          .getKarderTransferData(
            page,
            rowsPerPage,
            this.search,
            this.date,
            this.date2,
            this.searchType
          )
          .then((response) => {
            this.loading = false;
            this.itemsData = response.data[0];
            this.nroRows = response.data[1];
            this.totalrecords = response.data[1];
          });
      }

      //this.downloadexcel();
    },
    // getLenght() {
    //     console.log(this.nroRows);
    //     return this.nroRows;
    // },
    customFilter(item, queryText, itemText) {
      const textOne = item.description.toLowerCase();
      const textTwo = item.plu.toLowerCase();
      const textThree = String(item.id).toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.includes(searchText) ||
        textTwo.includes(searchText) ||
        textThree.includes(searchText)
      );
    },
    transferStatus(status) {
      switch (status) {
        case "PENDING":
          return "Pendiente";
        case "MEDICINE_NOT_FOUND":
          return "Medicamento inexistente";
        case "INSUFFICIENT_QUANTITY":
          return "Cantidad insuficiente";
        case "ERROR":
          return "Error";
        case "SUCCESSFUL":
          return "Exitoso";
        default:
          return "NA";
      }
    },
  },
};
